export default {
  feedback: {
    login_success: 'Erfolgreich eingeloggt',
    logout_success: 'Erfolgreich ausgeloggt',
  },
};
